import { LinkProps } from "react-router-dom";

export enum FooterLinkTypes {
  BET = "0",
  LEARN = "1"
}

export interface FooterButton {
  url: string;
  text: string;
}

export type HomeHeaderFooterLinkProp = LinkProps;
